import React from 'react';
import { getImageUrl } from '../../config';
import { formatDateTime } from '../../lib/formatDate';
// Comment-thread styles (ba-comment*) live here so they travel with the
// component on both the user and admin detail pages.
import './buildApp.css';

// Shared admin↔requester comment thread used on both the user and admin app
// detail pages. Presentational: the parent owns fetching, the composer value,
// and the post handler. `canPost` gates the composer only — the read-only
// thread above it always renders. Defaults to true: the user-facing detail
// page only ever loads for a participant (creator/collaborator), so it never
// needs to pass this; the admin detail page passes `can('apps.review')`
// since its payload doesn't expose viewer participation.
export default function CommentThread({ comments, body, setBody, onPost, posting, canPost = true }) {
  return (
    <div className="ba-comments">
      {comments.length === 0 ? (
        <p className="ba-muted ba-comments-empty">No messages yet. Start the conversation below.</p>
      ) : (
        <ul className="ba-comment-list">
          {comments.map((c) => (
            <li key={c.id} className={`ba-comment${c.is_admin ? ' ba-comment--admin' : ''}`}>
              {c.author_photo_url
                ? <img className="ba-comment-avatar" src={getImageUrl(c.author_photo_url)} alt="" />
                : <span className="ba-comment-avatar ba-comment-avatar--fallback" aria-hidden="true">{(c.author_name || '?').charAt(0).toUpperCase()}</span>}
              <div className="ba-comment-body">
                <div className="ba-comment-meta">
                  <span className="ba-comment-author">{c.author_name || 'Unknown'}</span>
                  {c.is_admin && <span className="ba-comment-badge">Admin</span>}
                  {c.created_at && <span className="ba-comment-time">{formatDateTime(c.created_at)}</span>}
                </div>
                <p className="ba-comment-text">{c.body}</p>
              </div>
            </li>
          ))}
        </ul>
      )}

      {canPost && (
        <div className="ba-comment-composer">
          <textarea
            className="ba-comment-input"
            rows={2}
            maxLength={2000}
            placeholder="Write a message…"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            aria-label="New comment"
          />
          <button type="button" className="btn btn-secondary btn-small" onClick={onPost} disabled={posting || !body.trim()}>
            {posting ? 'Sending…' : 'Send'}
          </button>
        </div>
      )}
    </div>
  );
}
